import React, { FC } from 'react'
import { CustomFade } from '../../'

interface IProps {
  children?: JSX.Element
}

const BlankLayout: FC<IProps> = ({ children }) => (
  <CustomFade>{children}</CustomFade>
)

export default BlankLayout
